import { lazy } from "react";
import { paths } from "~/router/paths";
import { app } from "~/helpers/routes";

const BackgroundGeneratorPage = lazy(
  () => import("~/pages/background-generator/index")
);

export const routes: Array<any> = [
  {
    path: paths["background-generator"].index,
    element: app(BackgroundGeneratorPage),
  },
];
